import { JadhuLanguage } from "../models";

export interface JadhuNavItem {
  label: string;
  route: string;
  exact?: boolean;
}

export const JADHU_NAV_ITEMS: JadhuNavItem[] = [
  {
    label: 'Home',
    route: '/',
    exact: true
  },
  {
    label: 'How it works',
    route: '/how-it-works'
  },
  {
    label: 'Roadmap',
    route: '/roadmap'
  },
  {
    label: 'Pricing',
    route: '/pricing'
  },
  {
    label: 'Science',
    route: '/science'
  },
  {
    label: 'For clinics',
    route: '/for-clinics'
  },
  {
    label: 'FAQ',
    route: '/faq'
  }
];


export const LANGUAGES: JadhuLanguage[] = [
    {
      code: 'en',
      label: 'EN'
    },
    {
      code: 'ta',
      label: 'தமிழ்'
    },
    {
      code: 'hi',
      label: 'हिंदी'
    }
  ];
